import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDropLogs } from "./SingleWaveDropLogs";
import { SingleWaveDropTechnicalDetails } from "./SingleWaveDropTechnicalDetails";
import { SingleWaveDropVoters } from "./SingleWaveDropVoters";
interface SingleWaveDropInfoDetailsProps {
  readonly drop: ExtendedDrop | undefined;
}
export const SingleWaveDropInfoDetails: React.FC<SingleWaveDropInfoDetailsProps> = t0 => {
  const $ = _c(10);
  const {
    drop
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = drop && <SingleWaveDropVoters drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop) {
    t2 = drop && <SingleWaveDropLogs drop={drop} />;
    $[2] = drop;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drop) {
    t3 = drop && <SingleWaveDropTechnicalDetails drop={drop} />;
    $[4] = drop;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="tw-rounded-lg tw-ring-1 tw-ring-white/10 tw-overflow-hidden tw-divide-y tw-divide-white/10 tw-divide-solid tw-divide-x-0">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};